<footer>
  <div class="div footer-wrapper">
    <section>
        <article class="info info-1">
            <div>
                <p><strong>Dirección de Impuestos y Aduanas Nacionales</strong></p>
                <p>Sede principal | Bogotá, Nivel Central, carrera 8 Nº 6C - 38 Edificio San Agustín | Código Postal 111711</p>
                <p>Horario Contact Center: Lunes a Viernes 8:00 a.m. a 7:00 p.m. y Sábados de 8:00 a.m. a 12:00 m.</p>
                <p><a  target="_blank" [href]="links.notificacionesJudiciales">Notificaciones Judiciales</a> | <a  target="_blank" [href]="links.mapaDelSitio">Mapa del sitio</a></p>
            </div>
            <div class="social-items">
                <ul>
                    @for (socialItem of socialItems;  track index; let index = $index) {
                        <li>
                            <a [attr.aria-label]="socialItem.label" [href]="socialItem.link" target="_blank"><div [innerHTML]="socialItem.icon"></div></a>
                        </li>
                    }
                </ul>
            </div>
        </article>
        <article class="info info-2">
            <div>
                <p><span class="icon-phone"></span><strong>Contacto</strong></p>
                <p><strong>Contact Center</strong></p>
                <p>57 601 489 9000 Línea de Contact Center atención de Impuestos</p>
                <p>57 601 794 8880 Línea de Contact Center atención de Aduanas</p>
                <p>57 601 794 8883 Línea Centro Nacional de Cobro</p>
                <p>Nivel central: PBX 601 4823294 / (+57) 3009140830</p>
                <p><strong>Servicio en Línea de Contacto</strong></p>
                <p><a target="_blank" [href]="links.pqsr">PQSR y Denuncias</a> | <a target="_blank" [href]="links.puntosDeContacto">Puntos de contacto</a></p>
                <p><a target="_blank" [href]="links.politicaSeguridadInformacion">Política de Seguridad de la Información</a></p>
                <p><a target="_blank" [href]="links.politicaPrivacidadYTerminos">Políticas de privacidad y términos de uso</a></p>
                <p><a target="_blank" [href]="links.politicaDatosPersonales">Política de Tratamiento de Datos Personales</a></p>
            </div>
        </article>
        <article class="institution-logos">
            <ul>
                <li><a target="_blank" aria-label="Gov Co" [href]="links.govCo"><span style="background-image: url({{imgGovCo}});" alt=""></span></a></li>
                <li><a target="_blank" aria-label="Colombia.co" [href]="links.co"><span style="background-image: url({{logoCo}});" alt=""></span></a></li>
            </ul>
        </article>
    </section>
  </div>
</footer>
